import { PartIcon } from '@/icons/parts';
import { fx, type CurrencyCode } from '@/lib/currency';
import type { CartLine } from '@/stores/cartStore';

interface LineItemRowProps {
  line: CartLine;
  currency: CurrencyCode;
  onUpdate: (patch: Partial<Omit<CartLine, 'partId' | 'snapshot'>>) => void;
  onRemove: () => void;
}

export default function LineItemRow({ line, currency, onUpdate, onRemove }: LineItemRowProps) {
  const subtotal = line.qty * line.unitPrice;

  return (
    <tr>
      <td className="line-part">
        <div className="part-cell">
          <div className="part-thumb">
            <PartIcon iconId={line.snapshot.iconId} size={26} />
          </div>
          <div className="part-cell-text">
            <div style={{ fontWeight: 600, color: 'var(--cream)' }}>{line.snapshot.title}</div>
            <small>{line.snapshot.sku}{line.snapshot.casting ? ` · ${line.snapshot.casting}` : ''}</small>
          </div>
        </div>
      </td>
      <td data-label="Qty" style={{ textAlign: 'right' }}>
        <input
          className="qty"
          type="number"
          min="1"
          step="1"
          value={line.qty}
          onChange={(e) => {
            const next = Math.max(1, Math.round(parseFloat(e.target.value) || 1));
            onUpdate({ qty: next });
          }}
        />
      </td>
      <td data-label="Unit Price" style={{ textAlign: 'right' }}>
        <input
          className="price"
          type="number"
          min="0"
          step="50"
          value={line.unitPrice}
          onChange={(e) => onUpdate({ unitPrice: parseFloat(e.target.value) || 0 })}
        />
      </td>
      <td data-label="Weight (lbs)" style={{ textAlign: 'right' }}>
        <input
          className="weight"
          type="number"
          min="0"
          step="0.5"
          value={line.shippingWeight}
          onChange={(e) => onUpdate({ shippingWeight: parseFloat(e.target.value) || 0 })}
        />
      </td>
      <td data-label="Subtotal" className="subtotal">{fx(subtotal, currency)}</td>
      <td className="actions">
        <button type="button" className="row-delete" onClick={onRemove} aria-label="Remove line">
          ×
        </button>
      </td>
    </tr>
  );
}
